module.exports = __webpack_public_path__ + "static/media/mobile_wd_page_area01_img_cn.79e6e7e9.png";